import * as actions from 'src/constants/actionTypes'
import fetch from 'src/utils/fetch'
import { parseJSON } from 'src/utils/http'

const api = ({ dispatch, getState }) => (next) => (action) => {
    if (action.type !== actions.API) {
        return next(action)
    }
    const {
        method,
        data,
        payload: { url, start, success, error },
    } = action
    if (start) {
        dispatch(start())
    }
    fetch[method.toLowerCase()](url, data || {})
        .then(parseJSON)
        // .then(data => parseJSON(data, true))
        .then((data) => {
            const newActionToDispatch = success(data)

            if (newActionToDispatch) {
                dispatch(newActionToDispatch)
            }
        })
        .catch((e) => {
            console.error(
                'Encountered error when performing api call',
                action,
                e
            )
            dispatch(error(e))
            // throw(e);
        })
}

export default api
